import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CbicContentMst, ICbicContentMst } from '../cbic-content-mst.model';
import { ICbicDocMst } from 'app/entities/cbic-doc-mst/cbic-doc-mst.model';
import { ChangeLanguageService } from 'app/core/util/change-language.service';
import { UtilsService } from 'app/core/util/view-file.component';
import { Navigation, ContentNavigationService } from './services/content-navigation.service';
import { CbicMenuMstService } from 'app/entities/cbic-menu-mst/service/cbic-menu-mst.service';

@Component({
  selector: 'cbic-view-data',
  templateUrl: './view-content.component.html',
})
export class ViewContentComponent implements OnInit {
  @Input() isBreadcrumb? = true;
  @Input() cbicContentMst?: ICbicContentMst | null;
  flag=true;
  @Input() showClose?: boolean | false;
  modelRef: any = null;
  topNavigation: Navigation[] = [];
  @ViewChild('searchText') searchText:any;
  //searchText: any = '';
  public topNavigationService: ContentNavigationService;

  constructor(protected activatedRoute: ActivatedRoute,
    private changeLnService:ChangeLanguageService, 
    public utils: UtilsService,
    private menuService:CbicMenuMstService 
    ) {
      this.topNavigationService = new ContentNavigationService(menuService);
    }

  ngOnInit(): void {
    console.log(this.cbicContentMst?.contentType?.id);
     
    this.flag = true;
    if(this.cbicContentMst)
    {
      if(this.isBreadcrumb){
        this.topNavigationService.updateNavigator(this.cbicContentMst);
      }
    }
    else
    {
    this.activatedRoute.data.subscribe(({ cbicContentMst}) => {
      if(!cbicContentMst) {
        return;
      }
      this.cbicContentMst = cbicContentMst;
      console.log(this.cbicContentMst);
      // clear top navigation links if switched to different category
      if(this.isBreadcrumb){
        this.topNavigationService.updateNavigator(cbicContentMst);
      }
    });
   // this.cbicContentMst = cbicContentMst;
  }

}
  
  hasInfo(content: CbicContentMst): boolean{
    if(this.changeLnService.getLanguage() === 'hi' && content.infoHi){
      return true;
    }else if(content.infoEn){
      return true;
    }
    return false;
  }
  
  previousState(): void {
    window.history.back();
  }
  
  closeModel() {
    if (this.modelRef) {
      this.modelRef.close();
    }
  }
  viewFile(doc: ICbicDocMst) {
    let filePath = doc.filePathEn;
    if(this.changeLnService.getLanguage() === 'hi' && doc.filePathHi){
      filePath = doc.filePathHi;
    }
    this.utils.viewOpenning(filePath ?? "");
  }


}